import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

export const createLogSearchNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'log',
  text: translateFn('mnu_logs_view'),
  identity: '/secure/log/search',
  permission: ['VIEW_AUDIT', 'VIEW_LOG'],
}))

export default Loadable(() => import('./LogSearch'))
